import { render, staticRenderFns } from "./NotifyNotFound.vue?vue&type=template&id=7ee9d1aa"
import script from "./NotifyNotFound.vue?vue&type=script&lang=ts"
export * from "./NotifyNotFound.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports